<div style="display: flex; flex-direction: row; justify-content: flex-start; align-items:center; gap: 5px;">
	<mat-icon [style.color]="region?.color">bubble_chartroup</mat-icon>
	<span>{{ region?.name }}</span>
</div>
